// src/utils/dateUtils.js
const moment = require('moment-timezone');

const formatDateToBrazilTime = (dateString) => {
  const timeZone = 'America/Sao_Paulo';
  return moment.tz(dateString, timeZone).format('YYYY-MM-DD HH:mm:ss');
};

module.exports = formatDateToBrazilTime;